import type { ProductFeatureConfig } from '../../../types/insurances/ProductFeatureConfig';

export const product: ProductFeatureConfig = {
    overview: {
        showSharedOverview: true,
        details: {
            showStatus: false,
            showVariant: true,
            showPackage: false,
            fallbackAssistancePhonesKey: null,
            fallbackAssistanceEmailsKey: null,
        },
    },
};
